'use strict';

angular.module('2FaAuth', [
    'ngKomondor'
]);
